<template>
  <section class="block-about about">
    <div class="about__content container">

      <h2 class="about__title title">ФитнесМания – это</h2>

      <ul class="about__list">
        <li
          class="about__list-item"
          v-for="(item, i) in about_list"
          :key="i"
          v-html="item"
        ></li>
      </ul>
<!--      <button-->
<!--        class="about__btn button button_theme_primary"-->
<!--        @click="-->
<!--          getCall({ type: 'sale', form: 'about', title: 'Узнать больше' })-->
<!--        "-->
<!--      >-->
<!--        <span>Узнать больше</span>-->
<!--      </button>-->
    </div>
  </section>
</template>

<script>
import Mixin from "../common/mixin";

export default {
  name: "block-about",
  mixins: [Mixin],
  data() {
    return {
      swiper: null,
      slides: 4,
      about_list: [
        "200 тренажёров Technogym",
        "Современная cycle-студия",
        "Зона функционального тренинга",
        "Просторная кардиозона",
        "Более 20 видов групповых программ",
        "Финаская сауна и солярий",
        "Более 600 шкафов в раздевалках",
        "В 1 минуте от метро Фрунзенская",
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.about {
  //display: flex;
  //align-items: center;

  &__content {
    display: flex;
    align-items: stretch;
    margin-top: 3em;
    margin-bottom: 4em;
    padding-left: 40px;
    padding-right: 24px;
  }

  &__title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 35px;
    //line-height: 0.72;
    text-align: center;
    color: #000;
    white-space: nowrap;
    background-color: $primary;
    padding: 1em;
  }

  &__list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    //margin-top: 42px;
    flex-grow: 1;
    //columns: 2 auto;
    list-style: square;
  }

  &__list-item {
    display: flex;
    align-items: center;
    font-family: 'Roboto', "Bebas Neue", sans-serif;
    font-size: 15px;
    line-height: 3;
    //min-height: 1.4em;
    font-style: italic;
    font-weight: 500;
    //margin-bottom: 1em;
    margin-left: 50px;
    padding-left: 1.5em;
    border-bottom: 1px solid $primary;
    //margin-top: 24px;
    position: relative;

    &:last-child,
    &:nth-last-child(2) {
      border-bottom: none;
    }

    &:before{
      content: "";
      position: absolute;
      left: 0;
      //top: 0.4em;
      width: 0.8em;
      height: 0.8em;
      background-color: $primary;
    }
  }

  &__btn {
    max-width: 207px;
    margin-top: 30px;
    font-size: 20px;
  }
}

@media (max-width: 1200px) {
  .about {
    &__content {
      padding-left: 20px;
    }

    &__title{
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 30px;
      padding: 0.5em;
    }

    &__list-item {
      font-size: 14px;
    }

    &__btn {
      height: 44px;
      font-size: 14px;
      margin-top: 24px;
    }
  }
}

@media (max-width: 900px) {
  .about {
    &__content {
      flex-direction: column;
    }

    &__title{
      font-size: 2em;
      margin-bottom: 1em;
    }
  }

}

@media (max-width: 768px) {
  .about {

    &__content {
      flex-direction: column;
    }

    &__title{
      width: 100%;
      text-align: center;
      padding: 1em;
    }

    &__list-item {
      font-size: 0.8em;
      margin-left: 1em;
    }
  }
}

@media (max-width: 550px) {
  .about {

    &__list {
      grid-template-columns: 1fr;

      &-item:nth-last-child(2) {
        border-bottom: 1px solid $primary;
      }
    }
  }
}

@media (max-width: 450px) {
  .about {
    &__title{
      font-size: 1.5em;
    }
    &__list {
      grid-template-columns: 1fr;
    }

    &__btn {

    }
  }
}
</style>
